import * as angular from "angular";

angular
  .module('bringoz.admin.service-points')
  .constant('ServicePoints_PN', {
    database: 'service-points',
    isBranchEntity: false
  });
